import {defineMessages, FormattedMessage} from 'react-intl';
import {useMemo} from 'react';

import {view} from '@sail/ui';

import type {ConversationParticipant} from '@stripe-internal/conversations-client';
import {useTheme} from '@stripe-internal/conversations-ui';

import {MetaRow} from './MetaRow';

const messages = defineMessages({
  participantJoined: {
    id: 'conversations_ui.chat.row.participantJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name} has joined.',
  },
  supportAgentJoined: {
    id: 'conversations_ui.chat.row.supportAgentJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name}, a Stripe support agent, has joined the chat.',
  },
  salesAgentJoined: {
    id: 'conversations_ui.chat.row.salesAgentJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: 'Connected to {name}, a Stripe sales representative.',
  },
});

export const JoinRow = ({
  role,
  name,
}: {
  role?: ConversationParticipant['role'];
  name: string;
}) => {
  const theme = useTheme();

  const message = useMemo(() => {
    if (role === 'agent' && !theme.messageKey) {
      return messages.salesAgentJoined;
    }

    return messages.participantJoined;
  }, [role, theme]);

  return (
    <view.div data-testid="join-row">
      <MetaRow>
        <FormattedMessage {...message} values={{name}} />
      </MetaRow>
    </view.div>
  );
};

export default JoinRow;
